import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const slides = [
  {
    id: "chang-ye-de-ji-jie",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20misty%20snowy%20northeastern%20town%20at%20dawn%2C%20old%20railway%20station%20and%20warm%20street%20lights%2C%20atmospheric%20mood%20blue%20hour%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=hero-changye-2024&orientation=landscape",
    tag: "口碑剧集",
    title: "漫长的季节",
    subtitle: "十二集写尽一代人的青春与遗憾，豆瓣 9.4 分年度华语剧集。",
  },
  {
    id: "san-ti",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20cosmic%20scene%2C%20huge%20radio%20telescope%20dishes%20under%20a%20starry%20night%20sky%2C%20distant%20planet%20glowing%20on%20the%20horizon%2C%20deep%20blue%20tones%2C%20epic%20scale%2C%20no%20text&width=1600&height=900&seq=hero-santi-2024&orientation=landscape",
    tag: "科幻巨制",
    title: "三体",
    subtitle: "从红岸基地到古筝行动，东方哲思与硬核科幻的影像化呈现。",
  },
  {
    id: "liu-lang-di-qiu-2",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20panorama%2C%20giant%20earth%20engine%20and%20space%20elevator%20under%20a%20frozen%20stormy%20sky%2C%20small%20astronaut%20figures%20for%20scale%2C%20blue%20and%20orange%20contrast%2C%20no%20text&width=1600&height=900&seq=hero-wandering2-2024&orientation=landscape",
    tag: "院线大片",
    title: "流浪地球 2",
    subtitle: "移山计划全面启动，人类用勇气与牺牲延续文明的火种。",
  },
  {
    id: "xing-ji-chuan-yue",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20outer%20space%20scene%2C%20astronaut%20spaceship%20approaching%20a%20giant%20ringed%20planet%20and%20luminous%20black%20hole%2C%20starlight%20and%20nebula%2C%20awe%20inspiring%2C%20no%20text&width=1600&height=900&seq=hero-interstellar-2024&orientation=landscape",
    tag: "经典重温",
    title: "星际穿越",
    subtitle: "穿越虫洞寻找新家园，把父女之爱写进时间的尺度里。",
  },
];

export default function HeroCarousel() {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5500);
    return () => window.clearInterval(timer);
  }, []);

  const goTo = (i: number) => setIndex(((i % slides.length) + slides.length) % slides.length);

  return (
    <section className="relative w-full h-[460px] md:h-[600px] overflow-hidden bg-primary-950">
      {slides.map((slide, i) => (
        <button
          key={slide.id}
          type="button"
          onClick={() => navigate(`/detail/${slide.id}`)}
          className={`absolute inset-0 w-full h-full text-left transition-opacity duration-700 cursor-pointer ${
            i === index ? "opacity-100 z-10" : "opacity-0 z-0 pointer-events-none"
          }`}
          aria-label={slide.title}
        >
          <img
            src={slide.image}
            alt={`${slide.title} 影视资讯焦点图`}
            title={`${slide.title} 剧情介绍`}
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/50 to-primary-950/40"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="w-full px-4 md:px-6 max-w-4xl">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-foreground-950 text-xs font-bold mb-4">
                <i className="ri-fire-fill"></i>
                {slide.tag}
              </span>
              <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-3 md:mb-4">
                {slide.title}
              </h2>
              <p className="text-sm md:text-base text-background-100/85 max-w-xl mb-6 md:mb-7 leading-relaxed">
                {slide.subtitle}
              </p>
              <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-50 text-primary-700 text-sm font-medium">
                查看剧情详情
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </div>
        </button>
      ))}

      <div className="absolute z-20 bottom-5 md:bottom-8 left-0 right-0 px-4 md:px-6 flex items-center justify-between">
        <div className="flex items-center gap-2">
          {slides.map((slide, i) => (
            <button
              key={slide.id}
              type="button"
              onClick={() => goTo(i)}
              className={`h-1.5 rounded-full transition-all cursor-pointer ${
                i === index ? "w-8 bg-accent-500" : "w-3 bg-background-50/40 hover:bg-background-50/70"
              }`}
              aria-label={`切换到第 ${i + 1} 张`}
            ></button>
          ))}
        </div>
        <div className="hidden sm:flex items-center gap-2">
          <button
            type="button"
            onClick={() => goTo(index - 1)}
            className="w-9 h-9 rounded-full bg-background-50/15 backdrop-blur text-background-50 flex items-center justify-center hover:bg-background-50/30 transition-colors cursor-pointer"
            aria-label="上一张"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>
          <button
            type="button"
            onClick={() => goTo(index + 1)}
            className="w-9 h-9 rounded-full bg-background-50/15 backdrop-blur text-background-50 flex items-center justify-center hover:bg-background-50/30 transition-colors cursor-pointer"
            aria-label="下一张"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}